import { render, staticRenderFns } from "./Situation.vue?vue&type=template&id=70e992d8&"
import script from "./Situation.vue?vue&type=script&lang=js&"
export * from "./Situation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports